









































































































































































































// :page="productsPage"
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
// @ts-ignore
import { mapFields } from 'vuex-map-fields';

import ProductQuotationModal from '../modals/ProductQuotationModal.vue';
import _ from 'lodash';
import { Debounce } from 'vue-debounce-decorator';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'products',
    data: function () {
        return {
            productsPageTest: 1,
        };
    },
    components: {
        ProductQuotationModal,
        Spinner,
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('products', ['allProducts', 'allProductsLoading', 'productsPerPage', 'productsPage', 'productsTotal', 'cacheClients', 'message']),
        ...mapFields({
            activeQuotation: 'products.activeQuotation',
            client: 'products.client',
        }),
        ...mapState('products', {
            allProducts: (state: any) => {
                const allProducts = state.allProducts.map((product: any) => {
                    if (!product.precio2) {
                        product.precio2 = 0;
                    }
                    if (!product.precio3) {
                        product.precio3 = 0;
                    }
                    return {
                        ...product,
                    };
                });
                return allProducts;
            },
        }),
    },
})
export default class Products extends Vue {
    private currentUser!: any;
    public activeQuotation!: any;
    public allProducts!: any;
    public allProductsLoading!: any;
    public productsPerPage!: any;
    public productsPage!: any;
    public productsTotal!: any;
    public productsPageTest!: any;
    public client!: any;
    public searchQuery: string = '';
    public message!: string;

    allProductsHeaders = [
        { thClass: 'th', key: 'product_link', label: '' },
        { thClass: 'th', sortable: true, key: 'sku', label: 'SKU' },
        { thClass: 'th', sortable: true, key: 'manufacturersku', label: 'Clave de Fabricante' },
        { thClass: 'th', key: 'descripcion1', label: 'Descripción' },
        { thClass: 'th', sortable: true, key: 'stock_total', label: 'Existencias' },
        { thClass: 'th', key: 'price', label: 'Precio' },
        { thClass: 'th', key: 'quotation', label: 'Cotización' },
    ];

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    onRemoveQuotationItem(product: any) {
        const index = this.activeQuotation.products.findIndex((p: any) => p.sku == product.sku);
        this.activeQuotation.products.splice(index);
    }

    onAddQuotationItem(product: any) {
        //
        let qty: any = prompt('Ingresa cantidad:', '');
        qty = qty.replace(/[^0-9.]/g, '');

        if (qty != null && qty != '') {
            this.activeQuotation.products.push({
                ...product,
                qty,
                note: '',
            });
        } else {
            alert('No se agregó el articulo, revisa valor ingresado');
        }
    }

    onEmptyQuotation() {
        this.activeQuotation = {
            clientName: '',
            clientEmail: '',
            clientPhone: '',
            products: [],
        };
    }

    onOpenQuotationModal() {
        // @ts-ignore
        this.$bvModal.show('product-quotation-modal');
    }

    setUrlPage(page: any) {
        // @ts-ignore
        this.$router
            .push({
                path: 'products',
                query: {
                    ...this.$route.query,
                    page,
                },
            })
            .catch((err) => {
                // console.log('');
            });
        this.productsPageTest = page;
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'products',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'DESC' : 'ASC',
            },
        });
    }

    setUrlSearch(search: string) {
        // @ts-ignore
        search = search.trim();
        this.$router.push({
            path: 'products',
            query: {
                ...this.$route.query,
                search,
            },
        });
        this.setUrlPage(1);
    }

    setUrlSearchClient(client: any) {

        // @ts-ignore
        this.$store.dispatch('products/getClient', {
            client: client.cliente,
            vm: this,
        });
    }

    @Watch('searchQuery')
    @Debounce(600)
    updateClientsList(search: string) {
        search = search.toUpperCase();
        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('products/cacheAllClients', { search, limit: 40 });
        }
    }

    clearFilters() {
        // console.log(this.client);
        this.client = {
            cliente: null,
            listapreciosesp: null,
        };
        this.searchQuery = '';
        this.activeQuotation.intelisis = false;
        this.$router.push({
            path: 'products',
            query: {},
        });
        this.productsPageTest = 1;
    }

    @Watch('$route')
    getAllProducts() {
        // @ts-ignore
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const sortName = this.$route.query.sortName || null;
        const sortValue = this.$route.query.sortValue || null;
        this.$store.dispatch('products/fetchAll', {
            page,
            search,
            sortName,
            sortValue,
        });
    }

    mounted() {
        this.getAllProducts();
        this.productsPageTest = 1;
    }
}
